import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrdersContext, {
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, Switch } from '@atom/mui';

import classes from './workOrdersFilters.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const WorkOrdersFiltersFormSection = () => {
  const { workOrdersInputCart, filtersDisabled, dispatch } =
    useContext(WorkOrdersContext);

  const handleChange = (event: any) => {
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property: 'hasForms',
        value: !workOrdersInputCart?.hasForms,
      },
    });
  };

  return (
    <div className={classes.filtersSection}>
      <div className={clsx(classes.filtersSectionHeader, classes.toggle)}>
        <div>
          <Icon style={styles.icon}>library_books</Icon>
          Forms
        </div>
        <Switch
          sx={{ marginRight: 0 }}
          checked={workOrdersInputCart?.hasForms}
          disabled={filtersDisabled}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default WorkOrdersFiltersFormSection;
